import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Unit from "./Unit";
import UnitCommutings from "./UnitCommutings";
import GridConfig from "../GridConfig";
import ImportExcel from "../ImportExcel";

export default class Units extends Base {
    constructor(props) {
        super(props);
        this.state = {
            buildingId: props.BuildingId,
            caller: props.Caller,
            controllerName: 'building/unit',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'building/unit_grid',
            moduleName: 'واحدهای ساختمان ها'
        };
        this.state.filters = {
            buildingId: this.state.buildingId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Unit BuildingId={this.state.buildingId} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Unit BuildingId={this.state.buildingId} Caller={this} /> });
    }
    onImport() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={13} BuildingId={this.state.buildingId} CompanyId={this.state.data.global.company.id} /> });
    }
    showUnitCommutings(unitId) {
        this.removeKeyDown();
        this.showComponents({ component: <UnitCommutings BuildingUnitId={unitId} Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "ownersName", caption: "مالکین", show: true },
                { field: "customerName", caption: "مستاجر", show: true },
                { field: "empty", caption: "خالی است", show: true },
                { field: "floor", caption: "طبقه", show: true },
                { field: "unitNumber", caption: "واحد", show: true },
                { field: "parking", caption: "پارکینگ", show: true },
                { field: "parking2", caption: "پارکینگ 2", show: true },
                { field: "anbar", caption: "انباری", show: true },
                { field: "numberPeople", caption: "تعداد نفرات", show: true },
                { field: "metrag", caption: "متراژ", show: true },
                { field: "shareOfTotal", caption: "سهم از کل", show: true },
                { field: "buildingUnitCategoryTitle", caption: "گروه", show: true },                  
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'ownersName' && f.show) t.push({
                field: f.field, headerName: f.caption, flex: 2,
                cellRenderer: (props) => {
                    return props.data.owners.map(ow => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "0 2px", "display": "inline-block" }} >{ow.personName}</span>)
                }
            });
            if (f.field == 'customerName' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'empty' && f.show) t.push({
                field: f.field, headerName: f.caption,
                cellRenderer: (props) => { return props.data.empty ? <span className="text-danger">بله</span> : <span className="text-success">خیر</span> }
            });
            if (f.field == 'unitNumber' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'floor' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'parking' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'parking2' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'anbar' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'numberPeople' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'metrag' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'shareOfTotal' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'buildingUnitCategoryTitle' && f.show) t.push({ field: f.field, headerName: f.caption });
        });

        t.push({
            field: "", filter: false, flex: 1, headerName: "عملیات", cellRenderer: (props) => {
                return <ul className="flex flex-row">
                    <li>
                        <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                            <em className="icon ni ni-cross-fill-c"></em>
                        </a>
                        <a className="hand text-primary mx-1" onClick={e => this.onEdit(props.data.id)} title="ویرایش">
                            <em className="icon ni ni-pen"></em>
                        </a>
                        <a className="hand text-warning mx-1" onClick={e => this.showUnitCommutings(props.data.id)} title="ورود و خروج">
                            <em className="icon ni ni-users"></em>
                        </a>
                    </li>
                </ul>
            }
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">واحد ها</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, {
                                    add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                                    otherFilters: [
                                       <a onClick={e => this.onImport()} className="hand btn btn-warning ms-2">ورود اکسل</a>
                                    ]
                                })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}